import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { IPageMeta } from "@/services/interfaces";

const initialMeta = {
  h1: "",
  title: "",
  breadcrumbs: [],
};

@Module({
  name: "complaints",
  namespaced: true,
})
export default class Complaints extends VuexModule {
  meta: IPageMeta = initialMeta;
  categories = [];
  upperCategories = [];
  files = [];

  get getMeta() {
    return this.meta;
  }

  get getCategories() {
    return this.categories;
  }

  get getUpperCategories() {
    return this.upperCategories;
  }

  get getFiles() {
    return this.files;
  }

  @Mutation
  setMeta(meta: IPageMeta) {
    this.meta = meta;
  }

  @Mutation
  setCategories(data: any) {
    this.categories = data;
  }

  @Mutation
  setUpperCategories(data: any) {
    this.upperCategories = data;
  }

  @Mutation
  setFiles(data: any) {
    this.files = data;
  }

  @Action
  async requestComplaints(params: any): Promise<void> {
    let url;

    switch (params.route) {
      case "complaints":
        url = "/api/complaints/";
        break;
      case "complaints-detail":
        url = "/api/complaints/category/" + params.pathMatch;
        break;
      case "digital-catalog":
        url = "/api/digital-catalog/";
        break;
      case "digital-catalog-detail":
        url = "/api/digital-catalog/category/" + params.pathMatch;
        break;
      default:
        break;
    }

    try {
      const res = await axios({
        method: "GET",
        url,
      });
      if (res.data?.data) this.setCategories(res.data?.data.categories);
      if (res.data?.data)
        this.setUpperCategories(res.data?.data.upper_categories);
      if (res.data?.data) this.setFiles(res.data?.data.data);
      if (res.data?.meta) this.setMeta(res.data?.meta);
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }
}
